import { defineComponent as _defineComponent } from 'vue'
import StoreFileList from '../components/StoreFileList.vue';
import router from '../router/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreFilesView',
  setup(__props) {


const breadcrumbItems = [
  {
    text: 'Stores',
    disabled: false,
    href: router.match({
      name: 'stores',
    }).path,
  },
  {
    text: router.currentRoute.params.store,
    disabled: false,
    href: router.match({
      name: 'storeFiles',
      params: {
        store: router.currentRoute.params.store,
      },
    }).path,
  },
]


return { __sfc: true,breadcrumbItems, StoreFileList }
}

})